import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "about" */ '../views/Home.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/product/:id',
    name: 'Product',
    component: () => import(/* webpackChunkName: "about" */ '../views/Product.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/signin',
    name: 'SignIn',
    component: () =>
      import(/* webpackChunkName: "signin" */ '../views/Auth/SignIn.vue')
  },
  {
    path: '/uploadfile',
    name: 'UploadFile',
    component: () =>
      import(/* webpackChunkName: "signin" */ '../views/UploadFile.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/signout',
    name: 'SignOut',
    component: () =>
      import(/* webpackChunkName: "signup" */ '../views/Auth/SignOut.vue')
  },
  {
    path: '/notfound',
    name: 'Kayıt Bulunamadı',
    component: () =>
      import(/* webpackChunkName: "notfound" */ '../views/NotFound.vue'),

    meta: { requiresAuth: true }
  },
  {
    path: '/test/home',
    name: 'TesTHome',
    component: () => import(/* webpackChunkName: "about" */ '../views/Test/TestHome.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/test/product/:id',
    name: 'TestProduct',
    component: () => import(/* webpackChunkName: "about" */ '../views/Test/TestProduct.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/test/uploadfile',
    name: 'TestUploadFile',
    component: () =>
      import(/* webpackChunkName: "signin" */ '../views/Test/TestUploadFile.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/prp/home',
    name: 'PrpHome',
    component: () => import(/* webpackChunkName: "about" */ '../views/Prp/PrpHome.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/prp/product/:id',
    name: 'PrpProduct',
    component: () => import(/* webpackChunkName: "about" */ '../views/Prp/PrpProduct.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/prp/uploadfile',
    name: 'PrpUploadFile',
    component: () =>
      import(/* webpackChunkName: "signin" */ '../views/Prp/PrpUploadFile.vue'),
    meta: { requiresAuth: true }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const loggedIn = localStorage.getItem('user')

  if (to.matched.some((record) => record.meta.requiresAuth) && !loggedIn) {
    sessionStorage.setItem('redirectPath', to.path);
    next('/signin')
  } else if (
    to.matched.some((record) => record.meta.requiresVisitor) &&
    loggedIn
  ) {
    next('/')
  } else {
    next()
  }
})

export default router
